<template>
  <v-container>
    <v-layout text-xs-center wrap>
      <v-flex xs12>
        <v-img
          :src="require('./../../assets/dark-mode/logo.png')"
          class="my-3"
          contain
          height="100"
        ></v-img>
      </v-flex>

      <v-flex mb-4>
        <h1 class="display-2 font-weight-bold mb-3">
          <!-- Welcome to CarterNoir -->
        </h1>
        <h2 style="font-weight:900;">
          CLIMATE CONTROLLED WALK-IN WINE VAULTS<br />
        </h2>
        <br>
        <h3 style="font-weight:900;">….because we care for
          your wine like you do</h3>
        <br />
         <!-- This is the start of image examples -->
      <v-flex mb-5 xs12>
        <v-img :src="require('../../assets/fridges/Large-Fridge.png')"
          class="my-3"
          contain
        />
        <v-flex mb-4>
          <h2 style="font-weight:900;">
            <a href="https://firebasestorage.googleapis.com/v0/b/carternoir-au.appspot.com/o/Carter-Noir-Brochure.pdf?alt=media&token=4d496a3e-67c6-4c3c-bb24-c40d70c43596" target="_blank" @click="brochureClicked">CLICK HERE TO DOWNLOAD OUR BROCHURE</a>
          </h2>
        </v-flex>
      </v-flex>
        <br>
        <p class="subheading font-weight-regular">
          This site is currently under construction and we will be up soon .<br />
          <br>
          <br>
          <br />Enquiries please call:<br />
        </p>
        <p class="subheading font-weight-regular">
          Dudley Maudlin - <a href="tel:+61438088255" style="decoration:none;color:#ffffff" @click="phoneFooterClicked">(+61) 438 088 225</a><br /><br>
          email: <a href="mailto:info@seawardagencies.com.au" @click="emailClicked">info@seawardagencies.com.au</a>
        </p>
      </v-flex>

      <!-- This is the original listing for running through services -->
      <!-- <v-flex
        mb-5
        xs12
      >
        <h2 class="headline font-weight-bold mb-3">What's next?</h2>

        <v-layout justify-center>
          <a
            v-for="(next, i) in whatsNext"
            :key="i"
            :href="next.href"
            class="subheading mx-3"
            target="_blank"
          >
            {{ next.text }}
          </a>
        </v-layout>
      </v-flex> -->

      <!-- <v-flex
        xs12
        mb-5
      >
        <h2 class="headline font-weight-bold mb-3">Important Links</h2>

        <v-layout justify-center>
          <a
            v-for="(link, i) in importantLinks"
            :key="i"
            :href="link.href"
            class="subheading mx-3"
            target="_blank"
          >
            {{ link.text }}
          </a>
        </v-layout>
      </v-flex>

      <v-flex
        xs12
        mb-5
      >
        <h2 class="headline font-weight-bold mb-3">Ecosystem</h2>

        <v-layout justify-center>
          <a
            v-for="(eco, i) in ecosystem"
            :key="i"
            :href="eco.href"
            class="subheading mx-3"
            target="_blank"
          >
            {{ eco.text }}
          </a>
        </v-layout>
      </v-flex> -->
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "UnderConstruction",
  data: () => ({
    //   ecosystem: [
    //     {
    //       text: 'vuetify-loader',
    //       href: 'https://github.com/vuetifyjs/vuetify-loader'
    //     },
    //     {
    //       text: 'github',
    //       href: 'https://github.com/vuetifyjs/vuetify'
    //     },
    //     {
    //       text: 'awesome-vuetify',
    //       href: 'https://github.com/vuetifyjs/awesome-vuetify'
    //     }
    //   ],
    //   importantLinks: [
    //     {
    //       text: 'Documentation',
    //       href: 'https://vuetifyjs.com'
    //     },
    //     {
    //       text: 'Chat',
    //       href: 'https://community.vuetifyjs.com'
    //     },
    //     {
    //       text: 'Made with Vuetify',
    //       href: 'https://madewithvuetifyjs.com'
    //     },
    //     {
    //       text: 'Twitter',
    //       href: 'https://twitter.com/vuetifyjs'
    //     },
    //     {
    //       text: 'Articles',
    //       href: 'https://medium.com/vuetify'
    //     }
    //   ],
    //   whatsNext: [
    //     {
    //       text: 'Explore components',
    //       href: 'https://vuetifyjs.com/components/api-explorer'
    //     },
    //     {
    //       text: 'Select a layout',
    //       href: 'https://vuetifyjs.com/layout/pre-defined'
    //     },
    //     {
    //       text: 'Frequently Asked Questions',
    //       href: 'https://vuetifyjs.com/getting-started/frequently-asked-questions'
    //     }
    //   ]
  }),
  methods: {
    brochureClicked() {
      analytics.track("brochureClicked", {
        event: "brochureClicked",
        label: "brochureClicked"
      })
    },
    emailClicked() {
      analytics.track("emailClicked", {
        event: "emailClicked",
        label: "emailClicked"
      })
    },
    phoneFooterClicked() {
      analytics.track("phoneFooterClicked", {
        event: "phoneFooterClicked",
        label: "phoneFooterClicked"
      })
    }
  }
};
</script>